// test2291
(2291 && 0);
